









































import { Component } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import AccountForm from './../accountForm.vue'
import conFirm from './../confirm.vue'
import { post, get } from '@/fn/ajax'
import { clientListByGroup, addClientToGroup, delClientByGroup } from './client.api'
import { Tooltip, Modal, message } from 'ant-design-vue'
import XLSX from 'xlsx'
import Excel from './../excel/excel.js'
import TitleBack from '@/components/titleBack/titleBack.vue'
@Component({
  components: {
    AccountForm,
    conFirm,
    TitleBack
  }
})
export default class ClientConfigList extends ViewBase {
  lang = {}

  lang2: any = {}

  doc: any = null

  groupName: string = ''

  groupId: any = null

  columns: any = null

  pagination: any = null

  loading: boolean = false

  list: any = []

  deleteId: string = ''

  submiting: boolean = false

  createConfirm: boolean = false

  showLoadInfo: boolean = false

  createModal: boolean = false

  selectExcel: boolean = false

  editModal: boolean = false

  removeModal: boolean = false

  uploadData: any = null

  editStudent: any = null

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  handleTableChange(pagination: any) {
    // console.log(pagination)
    const pager: any = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    this.fetch({
      page: pagination.current
    })
  }

  cancelCreate() {
    this.createConfirm = false
  }

  async postDel(data: any) {
    this.submiting = true
    const res = await post('/api/UserRes/del', data)
    return res
  }

  async deleteResource() {
    const pdata: any = {
      rid: this.deleteId
    }
    try {
      const res = await this.postDel(pdata)
      this.submiting = false
      this.$message.success(res.msg)
      this.fetch({
        page: this.pagination.current || 1,
        phase: 0,
        subject: 0
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }
  cancelMod() {
    this.createModal = false
    this.selectExcel = false
    this.showLoadInfo = false
    this.editModal = false
    this.removeModal = false
  }

  async delClient(item: any) {
    const params: any = {
      client_group_id: this.groupId,
      client_id: item.client_id
    }
    this.loading = true
    try {
      const res = await delClientByGroup(params)
      this.fetch({
        page: this.pagination.current || 1
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }

  async addClient(item: any) {
    const params: any = {
      client_group_id: this.groupId,
      client_id: item.client_id
    }
    this.loading = true
    try {
      const res = await addClientToGroup(params)
      this.fetch({
        page: this.pagination.current || 1
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }

  async fetch(params: any = {}) {
    params.client_group_id = this.groupId
    this.loading = true
    try {
      const res = await clientListByGroup(params)
      const data = res.data
      this.loading = false
      const pagination: any = { ...this.pagination }
      pagination.total = data.total
      this.loading = false
      this.list = data.list
      this.pagination = pagination
    } catch (ex) {
      this.handleError(ex)
    }
  }

  toAdd() {
    this.createModal = true
  }

  clickUploadExcel() {
    this.selectExcel = true
  }

  createClass() {}
  setColums() {
    const lang: any = this.lang2
    this.columns = [
      {
        title: lang.clientId,
        dataIndex: 'client_id'
      },
      {
        title: lang.clientMac,
        dataIndex: 'mac'
      },
      {
        title: lang.status,
        dataIndex: 'client_group_status_desc'
      },
      {
        title: this.i18n.resource.operation,
        dataIndex: 'operation',
        width: '140px',
        className: 'texcenter operation',
        scopedSlots: { customRender: 'operation' }
      }
    ]
    this.fetch()
  }

  showLoading(show: boolean) {
    if (show) {
      this.submiting = true
    } else {
      this.submiting = false
    }
  }

  loadedExcel(data: any) {
    this.uploadData = data
    this.showLoadInfo = true
    this.selectExcel = false
    this.submiting = false
  }
  setExportExcelData(data: any) {
    const datas: any = []
    data.forEach((item: any) => {
      const stu: any = {}
      stu.stu_name = item.stu_name
      stu.stu_number = item.stu_number
      datas.push(stu)
    })
    return datas
  }

  refreshList() {
    this.cancelMod()
    this.fetch({
      page: this.pagination.current || 1
    })
  }

  created() {
    this.groupId = parseInt(this.$route.params.id, 10)
    this.groupName = this.$route.params.group
    this.doc = window.document
    this.lang = this.i18n.resource
    this.lang2 = this.i18n.vClients
    this.setColums()
  }
}
